import React, { Fragment, useEffect, useState } from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import CustomData from "pages/_components/CustomData/CustomData";
import Image from "pages/_components/Image";
import Button from "pages/_components/Button";
import { replace } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import * as i18nUtils from "util/i18n";
import { selectors as environmentSelectors, actions as environmentActions } from "reducers/environment";
import { Col, Row } from "react-bootstrap";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";

import EnvironmentHelpSlide from "../_components/EnvironmentHelpSlide";
import EnvironmentStepper from "../_components/EnvironmentStepper";
import PaywayTitle from "../_components/PaywayTitle";
import { useHistoricData } from "../hooks/useHistoricData";

const PAGE_ID = "StepAcceptPayway";

const StepAcceptPayway = ({ isMobile, isDesktop }) => {
    const dispatch = useDispatch();
    const [helpIsVisible, setHelpIsVisible] = useState(false);

    useEffect(() => {
        dispatch(environmentActions.restartEnvironmentStore());
    }, []);

    const items = Array.from([1, 2, 3, 4]);

    const noBackupData = true;
    const { getBackupDataByStepId } = useHistoricData(!noBackupData);

    const onHeaderBack = () => {
        getBackupDataByStepId("stepFinish");
        dispatch(replace("/environment/stepFinish"));
    };

    const saveResponse = (acceptPayway) => {
        dispatch(environmentActions.acceptPayway(acceptPayway));
    };

    return (
        <>
            <ResponsiveHeader onClickBack={onHeaderBack} id="legalPerson.title" showTitle={isMobile} />
            <Notification scopeToShow="environment" />
            <MainContainer className="onboarding">
                <EnvironmentStepper isMobile={isMobile} page={PAGE_ID} />
                <div className="step-container">
                    <PaywayTitle handleHelp={() => setHelpIsVisible(true)} isDesktop={isDesktop} />
                    <div className="illustration-alta-persona flex justify-center">
                        <Image src="images/figma/illustrations/onboardingPayway.svg" className="svg-image" />
                    </div>
                    <div className="py-6" />
                    <div className="box box-border-soft payway-box">
                        <p>
                            <CustomData titleText="onboarding.stepPayway.text3" titleTextType="I18N" />
                        </p>
                        <>
                            <ul>
                                {items.map((value) => (
                                    <li className="payway-list-li">
                                        <span>{i18nUtils.get(`onboarding.stepPayway.info.list.${value}`)}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    </div>

                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                className="btn-primary"
                                label="onboarding.stepPayway.accept"
                                loading={false}
                                block
                                onClick={() => saveResponse(true)}
                            />
                        </Col>
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                className="btn-outline"
                                label="onboarding.stepPayway.deny"
                                loading={false}
                                block
                                onClick={() => saveResponse(false)}
                            />
                        </Col>
                    </Row>
                </div>
            </MainContainer>

            <EnvironmentHelpSlide
                slideIsVisible={helpIsVisible}
                closeSlide={() => setHelpIsVisible(false)}
                isMobile={isMobile}
                page={PAGE_ID}
                isDesktop={isDesktop}
            />
        </>
    );
};

StepAcceptPayway.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetching: environmentSelectors.getFetching(state),
});

export default connect(mapStateToProps)(StepAcceptPayway);
